/**
 * The range picker keeps a January end in the same year as a December start,
 * then sorts the pair so January comes first. That turns
 * Dec 27 12:01 AM → Jan 3 (next year) into Jan 3 → Dec 27 of the same year,
 * which covers every theme already scheduled in between.
 *
 * A 12:01 AM start on the day another theme ends at 12:00 AM is a real gap
 * and must be left alone. Only repair an end that fell in Jan/Feb of the
 * start year while the start is still in Nov/Dec.
 *
 * Accepts dayjs or moment values (both are used by the picker).
 */
export function normalizeCrossYearRange(start, end) {
  if (!start || !end || !start.isValid?.() || !end.isValid?.()) {
    return [start ?? null, end ?? null];
  }

  if (!end.isBefore(start)) {
    return [start, end];
  }

  const sameYear = start.year() === end.year();
  const crossesNewYear = sameYear && start.month() >= 10 && end.month() <= 1;

  if (crossesNewYear) {
    const bumped = end.clone().add(1, "year");
    if (bumped.isAfter(start)) {
      return [start, bumped];
    }
  }

  // A backwards click that does not cross New Year still sorts chronologically.
  return [end, start];
}
